
<template>
  <div class="balanceAndBeans">
      <div class="accountContainer">
          <div class="switchPhone">
            <div class="nowPhone">
              <p>当前帐号:{{nowPhone}}</p>
            </div>
            <div class="change" @click="changeMobile()">
              <font>切换账号</font>
              <img src="../../assets/img/change.png" alt="" >
            </div>
          </div>
          <!-- <ul class="beanOrgold" style="background:white;">
            <li v-for="(tab,index) in tabs1" :class="{active1:iscur1==index}"   :key="index"  @click="iscur1=index,tabChange1(index + 1)">
              {{tab.name}}
            </li>
          </ul> -->
          <div class="myBalance" v-if="tabView=='1'">
            <ul class="beanContainer">
                  <li class="bean bean1"  v-for="(tab,index) in tabs2"  :class="{active:iscur2==index}"  :key="index"   @click="iscur2=index,tabChange2(tab.money,tab.id)" style="position:relative;">
                    <img src="../../assets/img/redBorder.png" alt=""   v-show="iscur2==index">
                    <p class="beanMoney beanMoney1">￥{{(Number(tab.money)/100) }}元</p>
                  </li>
            </ul>
            <div class="custom">
              <div class="customFont">
                <p>自定义金额</p>
                <p><span>当前余额:</span><span style="color:rgba(204,50,50,1);font-weight:500;">{{(Number(nowCustom)/100)}}</span></p>
              </div>
              <div class="importCustom">
                <input type="text" v-model="importCustom" @focus="off()"  @input='changeValu()'  οnpaste="return false" οncοntextmenu="return false"  οncοpy="return false" oncut="return false"  placeholder="请输入充值金额">
              </div>
              <div class="no"  v-if="isNo">
                您输入的金额超出上限,请分次充值。
              </div>
              <div class="buyBean">
                <div>
                  <img src="../../assets/img/nextBu.png" alt=""  @click="wechatBuy('1')" style="width:5.9rem;">
                </div>
                <p class="topAgreement">
                  购买即代表您已同意<a href="http://h5.cbct.cn/html/paymentA.html" style="color:#5AC8FA">《听见广播用户账户服务协议》</a>
                </p>
              </div>
              <div class="tips">
                  <p>充值说明:</p>
                  <p>1、您充值的账户余额可在听见广播APP钱袋功能中查看。</p>
                  <p>2、您所充值的余额仅可用于购买播豆、发放福袋。</p>
                  <p>3、充值后不可退款且无法提现，请您购买前须知。</p>
                  <p>4、如充值遇到问题，可拨打客服电话：010-64716868</p>
              </div>

            </div>
            
          
          
          </div>
          <div class="myBeans" v-if="tabView=='2'">
              <div class="goldLuckyContainer">
                <ul class="beanContainer">
                    <li class="bean"  v-for="(tab,index) in tabs"  :class="{active:iscur==index}"  :key="index"   @click="iscur=index,tabChange(tab.bean,tab.amount,tab.id)" style="position:relative;">
                      <img src="../../assets/img/redBorder.png" alt=""   v-show="iscur==index">
                      <p class="beanMoney">{{tab.bean}}播豆</p>
                      <p class="realMoney">{{(Number(tab.amount)/100) }}元</p>
                    </li>
                </ul>
                <div class="tips">
                  <p>购买说明:</p>
                  <p>1、账户中的播豆属于听见广播虚拟货币。</p>
                  <p>2、您所购买的播豆仅用于直播互动中给主持人送礼物。</p>
                  <p>3、播豆购买兑换比例为：1元人民币=10播豆。</p>
                  <p>4、如遇购买失败等问题，可拨打客服电话:010-64716868。</p>
                </div>
                <div class="buyBean">
                      <div>
                      <img src="../../assets/img/wechatBuy.png" alt=""  @click="wechatBuy('2')">
                      </div>
                      <p class="topAgreement">
                        购买即代表您已同意<a href="http://h5.cbct.cn/html/paymentA.html" style="color:#5AC8FA">《听见广播用户账户服务协议》</a>
                      </p>
                </div>
            
        

              </div>
      
            
          
          </div>
      </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import Swiper from "swiper";
export default {
  name: 'channelProgram',
  data(){
    return{
     tabs1:[{name:'充值余额'},{name:'充值播豆'}],
     iscur1:0,
     tabView: '2',
     tabs:[],
     tabs2:[],
     iscur2:'100',
     iscur:'100',
     bean:'',
     money:'',
     id:'',
     money1:'',
     id1:'',
     nowCustom:'',
     importCustom:'',
     isNo:false,
     nowPhone:'',
     type:'',
     order_id:'',
     msgs:'服务器开小差,请稍后重试',
    }
  },

  methods:{
    tabChange1:function(tab){
      this.tabView=tab;
      this.iscur='100';
      this.id='';
      this.iscur2='100';
      this.id1='';
    },
    tabChange:function(bean,money,id){
      this.bean=bean;
      this.money=money;
      this.id=id;
    },
    tabChange2:function(money,id){
      this.money1=money;
      this.id1=id;
      this.importCustom='';
    },
    // 切换账号
    changeMobile:function(){
        this.$router.push({
            path:'login',
            name:'login',
        })
    },
    // 购买播豆
    wechatBuy:function(type){
        this.type=type;
        if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.realPay(), false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.realPay());
                    document.attachEvent('onWeixinJSBridgeReady', this.realPay());
                }
            } else {
               this.realPay();
        }
    },
    realPay:function(){
          var obj={
              page:'pub',
            
          }
          if (this.type=='2') {
            if (this.id=='') {
                Toast({
                  message: '请选择购买数量',
                  position: 'center',
                  duration: 5000
                });
                return;
            }
            this.$set(obj,'id',this.id);
            this.$set(obj,'attach','charge');
          }
          if (this.type=='1') {
            if (this.id1=='' && this.importCustom =='') {
                Toast({
                  message: '请您选择充值金额',
                  position: 'center',
                  duration: 5000
                });
                return;
            }
            if(this.id1!='' && this.importCustom ==''){
              this.$set(obj,'id','0');
              this.$set(obj,'money',this.money1);
              this.$set(obj,'attach','lucky_charge');

            }else if(this.id1=='' && this.importCustom !=''){
              this.$set(obj,'id','0');
              this.$set(obj,'attach','lucky_charge');
              this.$set(obj,'money',Number(this.importCustom)*100);
            }
          }
      let self = this;
      self.api.post(this.cbct.https()+'/h5/pay/wechat-pay', this.qs.stringify(
        obj
      )).then((response)=>{
            if(response.c == this.cbct.code.successRes){
                  self.order_id=response.d.order_id;
                  var wxinfo =  JSON.parse(response.d.pay);
                  WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', {
                            "appId":wxinfo.appId,
                            "nonceStr":wxinfo.nonceStr,
                            "package":wxinfo.package,
                            "signType":wxinfo.signType,
                            "timeStamp":wxinfo.timeStamp,
                            "paySign":wxinfo.paySign,
                        },
                        function (res) {
                            WeixinJSBridge.log(res.err_msg + 'err');
                           
                             if (res.err_msg=='get_brand_wcpay_request:ok') {
                                Toast({
                                  message: '支付成功',
                                  position: 'center',
                                  duration: 1000
                                });
                             

                                self.$nextTick(function(){
                                 
                                  self.$router.push({
                                    path:'finishCharge?order_id='+self.order_id,
                                  })
                                })
                            }else if(res.err_msg=='get_brand_wcpay_request:cancel'){
                               Toast({
                                  message: '取消支付',
                                  position: 'center',
                                  duration: 1000
                                });
                            }else{
                                Toast({
                                  message: '支付失败',
                                  position: 'center',
                                  duration: 1000
                                });
                            }
                        }

                  );

            
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message:self.msgs,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./login?returnUrl=balanceAndBeans'});
            }else{
               Toast({
                    message:self.msgs,
                    position: 'center',
                    duration: 5000
                });
            }
            
        }
        ).catch((error)=>{console.log(error);})
    },
    off:function(){
      this.iscur2='100';
      this.id1='';
      this.money1='';   
    },
    changeValu:function(){
      if (this.importCustom !='') {
        this.iscur2='100';
        this.id1='';
        this.money1='';
      }
     
      if (this.importCustom==0) {
        this.importCustom='';
      }
      if (this.importCustom=='' || this.importCustom==undefined) {
         this.isNo=false;
         return;
      }
      if (!this.numberCheck(this.importCustom)){
        var regs=/[a-z,A-Z]/g;
        var reg =/[\u4e00-\u9fa5a-zA-Z]/g;
        var regEn = /[`~!@#$%^&*()_+-=<>?:。."{},\\/;'[\]]/im,
        regCn = /[·！#￥（——）：；“”‘’、，|《。》？、【】[\]]/im;
        // 去除input框输入的字母特殊符号
        for(var i = 0; i<this.importCustom.length; i++){
          if (/[\u4e00-\u9fa5_a-zA-Z]/g.test(this.importCustom[i]) ||  regEn.test(this.importCustom[i]) || regCn.test(this.importCustom[i]) ){
            this.importCustom=this.importCustom.replace(this.importCustom.charAt(this.importCustom.length-1),'');
           }
         }
         let a=String(this.importCustom);
         this.importCustom = a.replace(reg,'');
         return;
      }else{
        if (Number(this.importCustom)>2000) {
          this.isNo=true;
           if (parseInt(self.importCustom).toString().length > 6) {
                self.importCustom = self.importCustom.substr(0, 6) 
            } 
        }else{
          this.importCustom=Number(this.importCustom);
          this.isNo=false;
        }
      }
    },
    numberCheck:function(num){
      var re=/^$|^[1-9]\d*$/;
      return re.exec(num) != null;
    },

    getDate:function(){
        var self = this;
        self.api.post(this.cbct.https()+'/h5/channel/account/beans-charge-list', this.qs.stringify({
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
             this.tabs=response.d;
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: self.msgs,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                 self.$router.push({path:'./login?returnUrl=balanceAndBeans'});
            }else{
               Toast({
                    message:self.msgs,
                    position: 'center',
                    duration: 5000
                });
            }
            
        }
        ).catch((error)=>{console.log(error);})
    },
    getDate1:function(){
      var self = this;
        self.api.post(this.cbct.https()+'/h5/pay/balance', this.qs.stringify({
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
             this.tabs2=response.d.list;
             this.nowCustom=response.d.balance;
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message:self.msgs,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                 self.$router.push({path:'./login?returnUrl=balanceAndBeans'});
            }else{
               Toast({
                    message: self.msgs,
                    position: 'center',
                    duration: 5000
                });
            }
            
        }
        ).catch((error)=>{console.log(error);})
    },
 
  
   

   
  },
  created(){
   
      let self=this;
      this.getDate();
      this.getDate1();
      $('title').html("听见广播--充值");
      this.nowPhone=this.cbct.getCookie('mobile1')
  },
  watch:{
    tabView(n,o){
      // this.cbct.setCookie('tabView',n);
      if (n=='1') {
        this.getDate();
      }else if(n=='2'){
        this.getDate1();
      }
    },

  },
  mounted(){
    document.body.style.background="#F9F9F9";
    if (this.cbct.getCookie('tabView')!=''|| this.cbct.getCookie('tabView') != undefined) {
      //  let isActive=this.cbct.getCookie('tabView');
      //  if (isActive=='1') {
      //    this.iscur=0;
      //    this.tabView=1;
      //  }else if(isActive=='2'){
      //     this.iscur=1;
      //     this.tabView=2;
      //  }
    }
   
  },
  components: {
  },
 
}


</script>
<style scoped lang="scss">
   .balanceAndBeans{
      width: 100%;
      height: auto;
      overflow: hidden;
      box-sizing: border-box;
      .beanContainer{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 0.39rem 0.2rem 0.04rem; 
          
            .bean{
              width: 30%;
              margin-bottom: 0.15rem;
              background: white;
              border-radius: 0.1rem;
              padding: 0.25rem 0 0.15rem;
              .beanMoney{
                font-weight:400;
                color:rgba(51,51,51,1);
                font-size: 0.36rem;
                padding-bottom: 0.11rem;
              }
              .realMoney{
                font-weight:400;
                color:rgba(102,102,102,1);
                font-size: 0.24rem;
              }
              img{
                height: 1.42rem;
                width:100%;
                position:absolute;
                left:0;
                top:0;
              }

            }
            li.active{
              // border: solid 1px rgba(204,50,50,1);
              .beanMoney{
                color:rgba(204,50,50,1);
                padding-bottom: 0.11rem;
              }
              .realMoney{
                color:rgba(204,50,50,1);
              }
              .beanMoney1{
                padding: 0;
              }
            }
            .bean1{
              padding: 0;
              .beanMoney1{
                margin: 0;
                padding: 0;
                height: 1.41rem;
                line-height: 1.41rem;

              }
           

            }


      }
      .tips{
        font-weight:500;
        color:rgba(153,153,153,1);
        font-size: 0.24rem;
        padding: 0.4rem 0.31rem 0.6rem;
        text-align: left;
        line-height: 0.4rem;
      }
      .buyBean{
        width: 100%;
        margin: auto;
        text-align: center;
        img{
          width: 5.86rem;
          display: block;
          margin-left: 0.83rem;
        }
        .topAgreement{
          font-weight:500;
          font-size: 0.2rem;
          color:rgba(170,170,170,1);
          margin-top: 0.2rem;
        }
      }
      .accountContainer{
        width: 100%;
        box-sizing: border-box;
        .switchPhone{
          display: flex;
          align-items: center;
          padding: 0 0.32rem;
          height: 0.88rem;
          line-height: 0.88rem;
          font-size: 0.24rem;
          font-weight:400;
          color:rgba(51,51,51,1);
          justify-content: space-between;
          background: white;
          .change{
            color:rgba(153,153,153,1);
            img{
              width: 0.27rem;
              margin-left: 0.11rem;
            }

          }
        }
        .beanOrgold{
          display: flex;
          height: 0.92rem;
          line-height: 0.92rem;
          justify-content: center;
          align-items: center;
          li{
            width: 3.75rem;
            text-align: center;
            font-size:0.3rem;
            font-weight:500;
            color:rgba(51,51,51,1);
            padding-bottom: 0.03rem;
            border-bottom: solid 0.01rem rgba(221,221,221,1);;
            color: rgba(153, 153, 153, 1)
          }
          li.active1{
            font-weight:400;
            color:rgba(204,50,50,1);
            border-bottom: solid 0.04rem rgba(204,50,50,1);
          }

        }
        .myBalance{
          margin:auto;
          font-size: 0.28rem;
          width: 100%;
          box-sizing: border-box;
          .custom{
           
            .customFont{
              display: flex;
              align-items: center;
              padding: 0.2rem;  
              justify-content: space-between;

            }
            .importCustom{
              padding: 0.2rem;
              input{
                width: 100%;
                box-sizing: border-box;
                border-radius: 0.2rem;
                padding: 0.24rem 0;
                padding-left: 0.2rem;
                color:rgba(51,51,51,1);
                border: none;
                outline: none;
                background: white;
                color:rgba(51,51,51,1);
                font-size: 0.28rem;
                font-weight:500;
              }
              input::-webkit-input-placeholder {
                 font-weight:500;
                 color:rgba(153,153,153,1);
              }

            }
            .no{
              text-align: left;
              padding-left: 0.2rem;
              font-weight:400;
              color: rgba(204,50,50,1);
              margin-bottom: 0.2rem;
            }

          }
       
        }
        .myBeans{
          margin: auto;
          font-size: 0.28rem;
          .goldLuckyContainer{
              width: 100%;
              box-sizing: border-box;
            }
              

          }
     
       



      }
    
     
   }
 
</style>

